import styled from "styled-components";

const Button = styled.button`
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 100%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const RedButton = styled.button`
  background: rgb(234, 29, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 29, 19, 1) 0%,
    rgba(255, 60, 50, 1) 100%
  );
  width: 100%;
  border: 2px solid rgb(234, 29, 19);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;

const GreenButton = styled.button`
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  width: 100%;
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;

const LinkButton = styled.a`
  display: block;
  background: rgb(195, 195, 195);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 100%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 4em;
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;

const GreyedButton = styled.button`
  background: rgb(195, 195, 195);
  background: linear-gradient(
    0deg,
    rgb(195, 195, 195) 0%,
    rgb(150, 150, 150) 100%
  );
  width: 100%;
  border: 2px solid #a0a0a0;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;

export { Button, LinkButton, GreyedButton, GreenButton, RedButton };
